'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bezierUtil = require('../../../../common/maths/geometry/bezierUtil');

var _point = require('../../../../common/maths/geometry/point');

var pointsLib = _interopRequireWildcard(_point);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


var getLinePath = function getLinePath(_ref) {
    var start = _ref.start,
        end = _ref.end,
        controlPoint = _ref.controlPoint;

    if (!controlPoint || pointsLib.equals(start, controlPoint) || pointsLib.equals(end, controlPoint)) {
        return 'M' + start.x + ' ' + start.y + ' ' + end.x + ' ' + end.y;
    }

    var quadraticControlPoint = (0, _bezierUtil.calculateQuadraticControlPoint)(start, end, controlPoint);
    return 'M' + start.x + ' ' + start.y + ' Q ' + quadraticControlPoint.x + ' ' + quadraticControlPoint.y + ' ' + end.x + ' ' + end.y;
};

var LinePath = function (_React$Component) {
    _inherits(LinePath, _React$Component);

    function LinePath() {
        _classCallCheck(this, LinePath);

        return _possibleConstructorReturn(this, (LinePath.__proto__ || Object.getPrototypeOf(LinePath)).apply(this, arguments));
    }

    _createClass(LinePath, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                start = _props.start,
                end = _props.end,
                controlPoint = _props.controlPoint,
                rest = _objectWithoutProperties(_props, ['start', 'end', 'controlPoint']);

            return _react2.default.createElement('path', _extends({ d: getLinePath({ start: start, end: end, controlPoint: controlPoint }) }, rest));
        }
    }]);

    return LinePath;
}(_react2.default.Component);

LinePath.propTypes = {
    start: _propTypes2.default.object,
    end: _propTypes2.default.object,
    controlPoint: _propTypes2.default.object
};

exports.default = LinePath;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/svg/LinePath.js
// module id = 1996
// module chunks = 0